/*
 * Busy state for navigation submits no theme script covers (checkout buttons
 * in the cart drawer + cart page). Everything else already toggles .loading
 * itself (product-form.js, quick-add.js, load-more.js) and is painted by the
 * generic .button.loading rules in component-loading-overlay.css.
 */
(function () {
	document.addEventListener('submit', function (e) {
		if (e.defaultPrevented) return;
		var btn = e.submitter;
		if (!btn || btn.name !== 'checkout' || btn.classList.contains('loading')) return;
		btn.classList.add('loading');
		btn.setAttribute('aria-busy', 'true');
		// If an app or validation cancels the navigation, don't strand the state.
		setTimeout(function () {
			btn.classList.remove('loading');
			btn.removeAttribute('aria-busy');
		}, 8000);
	});

	// Back/forward cache restores the page exactly as it left — including a
	// checkout button frozen mid-spin. Clear any stale states on restore.
	window.addEventListener('pageshow', function (e) {
		if (!e.persisted) return;
		document.querySelectorAll('.button.loading, button.loading').forEach(function (b) {
			b.classList.remove('loading');
			b.removeAttribute('aria-busy');
		});
	});
})();
